import { DeleteModal, DeleteModalProps, Modal } from "@app/components/modals"
import { ModalInstance } from "@app/hooks/useModal"
import { IUser } from "@app/common";

interface UserDeleteModalProps extends ModalInstance<IUser>, Omit<DeleteModalProps<IUser>, 'children'> {
  onDelete: (user: Partial<IUser>) => void;
}

export const UserDeleteModal = (props: UserDeleteModalProps) => {
  return (
    <DeleteModal {...props} >
      <Modal.Subtitle>Vous allez supprimer un utilisateur.</Modal.Subtitle>
      <Modal.Message>
        Cette suppression est irréversible.
      </Modal.Message>
    </DeleteModal>
  )
}